export const DEFAULT_POPPER_OFFSET_Y = 2;
export const DEFAULT_POPPER_IS_USE_PORTAL = true;
export const DEFAULT_POPPER_OVERLAY_OPACITY = 0;
export const DEFAULT_POPPER_PLACEMENT = 'bottom-start';
